import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/our-team/OurTeam.tsx");
